/* Status badge — React port of PS.badge. Renders the mockup `.badge b-*` markup so
   the scoped CSS (incl. the non-colour dot SHAPE cues) applies. */
import React from 'react'
import PropTypes from 'prop-types'

const BADGES = {
  active: ['b-active', 'Active'],
  signed: ['b-active', 'Signed'],
  received: ['b-active', 'Received'],
  paid: ['b-active', 'Paid'],
  resolved: ['b-active', 'Resolved'],
  confirmed: ['b-active', 'Confirmed'],
  match: ['b-active', 'Match'],
  pending: ['b-pending', 'Pending'],
  addendum: ['b-pending', 'Signed + addendum pending'],
  due: ['b-pending', 'Due'],
  underreview: ['b-pending', 'Under review'],
  disputed: ['b-pending', 'Disputed'],
  open: ['b-pending', 'Open'],
  draft: ['b-draft', 'Draft'],
  uploaded: ['b-info', 'Uploaded'],
  initiated: ['b-info', 'Initiated'],
  info: ['b-info', 'Info'],
  expired: ['b-expired', 'Expired'],
  norecord: ['b-norecord', 'No agreement'],
  approvalpending: ['b-norecord', 'Approval pending'],
  overdue: ['b-error', 'Overdue'],
  reversed: ['b-error', 'Reversed'],
  failed: ['b-error', 'Failed'],
  rejected: ['b-error', 'Rejected'],
  mismatch: ['b-error', 'Mismatch'],
  deactivated: ['b-deact', 'Deactivated'],
  inactive: ['b-deact', 'Inactive'],
  suspended: ['b-deact', 'Suspended'],
  placeholder: ['b-ph', 'Coming soon'],
}

export default function Badge({status, label, title}) {
  const key = String(status || '')
    .toLowerCase()
    .replace(/[^a-z]/g, '')
  const b = BADGES[key] || ['b-grey', label || status]
  return (
    <span className={'badge ' + b[0]} title={title || undefined}>
      <span className='dot' />
      {label || b[1]}
    </span>
  )
}

Badge.propTypes = {
  status: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
}
